import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "hidden md:flex justify-start items-center" }
const _hoisted_2 = {
  type: "button",
  class: "inline-flex items-center justify-center rounded-md border bg-white hover:bg-gray-50 text-gray-600 px-3 py-2 w-28 text-sm font-medium focus:outline-none mr-2"
}
const _hoisted_3 = { class: "border-b pb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-sm block text-gray-700" }, " Loan amount ", -1)
const _hoisted_5 = { class: "grid grid-cols-8 gap-2 pt-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs red-600 pt-2"
}
const _hoisted_7 = ["for"]
const _hoisted_8 = {
  key: 0,
  class: "border-t mt-4"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "py-1.5 px-3 bg-yellow-100 mt-3 rounded-md" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs w-full text-yellow-800" }, "Remove footprints before applying distance")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-sm block text-gray-700 w-1/3 flex-shrink-0" }, " Distance ", -1)
const _hoisted_11 = { class: "w-full pr-2 py-3 flex items-center justify-between" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-400 pr-1" }, "Not set", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-400 block text-center pl-1" }, "100 miles", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-sm block text-gray-700 w-1/2 flex-shrink-0" }, " Originator's state ", -1)
const _hoisted_15 = {
  key: 0,
  class: "hidden md:flex items-center justify-start flex-wrap mr-6"
}
const _hoisted_16 = {
  key: 0,
  class: "cursor-pointer inline-flex items-center pl-3 pr-2 py-1 mx-1 rounded-full text-xs font-medium bg-indigo-100 hover:bg-indigo-200 text-sky my-0.5"
}
const _hoisted_17 = {
  key: 0,
  class: "cursor-pointer inline-flex items-center pl-3 pr-2 py-1 mx-1 rounded-full text-xs font-medium bg-indigo-100 hover:bg-indigo-200 text-sky my-0.5"
}
const _hoisted_18 = {
  key: 1,
  class: "cursor-pointer inline-flex items-center pl-3 pr-2 py-1 mx-1 rounded-full text-xs font-medium bg-indigo-100 hover:bg-indigo-200 text-sky my-0.5"
}
const _hoisted_19 = {
  key: 0,
  class: "cursor-pointer inline-flex items-center pl-3 pr-2 py-1 mx-1 rounded-full text-xs font-medium bg-indigo-100 hover:bg-indigo-200 text-sky my-0.5"
}
const _hoisted_20 = {
  key: 5,
  class: "cursor-pointer inline-flex items-center pl-3 pr-2 py-1 mx-1 rounded-full text-xs font-medium bg-indigo-100 hover:bg-indigo-200 text-sky my-0.5"
}
const _hoisted_21 = {
  key: 6,
  class: "cursor-pointer inline-flex items-center pl-3 pr-2 py-1 mx-1 rounded-full text-xs font-medium bg-indigo-100 hover:bg-indigo-200 text-sky my-0.5"
}
const _hoisted_22 = { class: "relative rounded-md shadow-sm flex-shrink-0" }
const _hoisted_23 = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterIcon = _resolveComponent("FilterIcon")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_RangeSlider = _resolveComponent("RangeSlider")!
  const _component_base_menu_toggle = _resolveComponent("base-menu-toggle")!
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_search_icon = _resolveComponent("search-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_base_menu_toggle, { "menu-styles": 'left-0 top-full w-80 py-3' }, {
        toggle: _withCtx(() => [
          _createElementVNode("button", _hoisted_2, [
            _createVNode(_component_FilterIcon, {
              class: "h-4 w-4 mr-1 text-gray-400",
              "aria-hidden": "true"
            }),
            _createTextVNode(" Add filter ")
          ])
        ]),
        items: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                placeholder: "From",
                class: _normalizeClass(["col-span-4 border h-10 rounded-md text-sm px-3", { 'border-red-600': _ctx.invalidLoanAmountRange }]),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loanAmountRange.minimumAmount) = $event))
              }, null, 2), [
                [_vModelText, _ctx.loanAmountRange.minimumAmount]
              ]),
              _withDirectives(_createElementVNode("input", {
                placeholder: "To",
                class: _normalizeClass(["col-span-4 border h-10 rounded-md text-sm px-3", { 'border-red-600': _ctx.invalidLoanAmountRange }]),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loanAmountRange.maximumAmount) = $event))
              }, null, 2), [
                [_vModelText, _ctx.loanAmountRange.maximumAmount]
              ])
            ]),
            (_ctx.invalidLoanAmountRange)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, " \"From\" should be less than \"to\" "))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterMetadata, (value, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "flex items-center justify-between my-1"
            }, [
              _createElementVNode("label", {
                for: key,
                class: "w-1/3 text-gray-700 font-medium text-sm"
              }, _toDisplayString(_ctx.filtersMap[key]), 9, _hoisted_7),
              (_openBlock(), _createBlock(_component_multiselect, {
                key: key,
                options: _ctx.displayedValuesMap[key],
                modelValue: _ctx.filtersData[key] ? Array.from(_ctx.filtersData[key]) : [],
                "onUpdate:modelValue": ($event: any) => (_ctx.onFilterChange(key, $event))
              }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]))
            ]))
          }), 128)),
          (_ctx.showDistanceFilter)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center", { 'opacity-50 pointer-events-none': _ctx.filtersData?.footprints?.size }])
                }, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_RangeSlider, {
                      modelValue: _ctx.distance,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.distance) = $event)),
                      color: "#003770",
                      "track-color": "#CCD3DE",
                      step: 5,
                      max: 100,
                      tooltip: true,
                      "tooltip-text": '%v miles',
                      "always-show-handle": true,
                      onChange: _ctx.handleDistanceChange
                    }, null, 8, ["modelValue", "onChange"]),
                    _hoisted_13
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center", { 'opacity-50 pointer-events-none': _ctx.filtersData?.footprints?.size }])
                }, [
                  _hoisted_14,
                  _createVNode(_component_multiselect, {
                    options: _ctx.displayedStatesMap,
                    modelValue: _ctx.filtersData['statesProvinces'] ? Array.from(_ctx.filtersData['statesProvinces']) : [],
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFilterChange('statesProvinces', $event)))
                  }, null, 8, ["options", "modelValue"])
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.appliedFilters.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedFilters, ({ key, value }, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                (key == 'showDeleted')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createTextVNode(" Include deleted records "),
                      _createVNode(_component_XIcon, {
                        class: "h-3 w-3 ml-1",
                        onClick: ($event: any) => (_ctx.onFilterChange(key, false))
                      }, null, 8, ["onClick"])
                    ]))
                  : (value instanceof Set)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(Array.from(value), (value, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "cursor-pointer inline-flex items-center pl-3 pr-2 py-1 mx-1 rounded-full text-xs font-medium bg-indigo-100 hover:bg-indigo-200 text-sky my-0.5",
                          key: index
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.typeNamesMap[value] || value) + " ", 1),
                          _createVNode(_component_XIcon, {
                            class: "h-3 w-3 ml-1",
                            onClick: ($event: any) => (_ctx.removeFilterValue(key, value))
                          }, null, 8, ["onClick"])
                        ]))
                      }), 128))
                    : (key === 'loanAmountRange')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          (value.minimumAmount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createTextVNode(" from $" + _toDisplayString(_ctx.convertToShortCurrency(value.minimumAmount)) + " ", 1),
                                _createVNode(_component_XIcon, {
                                  class: "h-3 w-3 ml-1",
                                  onClick: ($event: any) => (_ctx.onFilterChange(key, {
                minimumAmount: '',
                maximumAmount: value.maximumAmount
              }))
                                }, null, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true),
                          (value.maximumAmount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createTextVNode(" to $" + _toDisplayString(_ctx.convertToShortCurrency(value.maximumAmount)) + " ", 1),
                                _createVNode(_component_XIcon, {
                                  class: "h-3 w-3 ml-1",
                                  onClick: ($event: any) => (_ctx.onFilterChange(key, {
                minimumAmount: value.minimumAmount,
                maximumAmount: ''
              }))
                                }, null, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (key === 'balanceSheetRange')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [], 64))
                        : (key === 'nearby')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              (value.distance)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createTextVNode(" Less than " + _toDisplayString(value.distance) + " miles from property ", 1),
                                    _createVNode(_component_XIcon, {
                                      class: "h-3 w-3 ml-1",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFilterChange('nearby', {})))
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (key === 'name' || key === 'originatorName')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createTextVNode(_toDisplayString(value) + " ", 1),
                                _createVNode(_component_XIcon, {
                                  class: "h-3 w-3 ml-1",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchQuery = ''))
                                })
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createTextVNode(_toDisplayString(_ctx.typeNamesMap[value] || value) + " ", 1),
                                _createVNode(_component_XIcon, {
                                  class: "h-3 w-3 ml-1",
                                  onClick: ($event: any) => (_ctx.onFilterChange(key, ''))
                                }, null, 8, ["onClick"])
                              ]))
              ], 64))
            }), 128)),
            (_ctx.appliedFilters.length > 0)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "#clear-filters",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)), ["prevent"])),
                  class: "text-sky font-semibold text-xs ml-2"
                }, " Clear filters "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_search_icon, {
          class: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        name: "search",
        class: "focus:ring-indigo-800 focus:border-indigo-800 block w-full pl-10 sm:text-sm border-gray-300 rounded-md border h-10 text-left",
        placeholder: "Search",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchQuery) = $event))
      }, null, 512), [
        [_vModelText, _ctx.searchQuery]
      ])
    ])
  ], 64))
}